import Router from "./Router";
import { ThemeProvider } from "styled-components";
import { theme } from "./styles/theme";

import { CenterBackground } from "./common/components";
import { TailSpin } from "react-loader-spinner";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import withClearCache from "./clearCache";
import { useRefresh } from "./useRefresh";
import { useEffect } from "react";

function App() {
  const { isLoading, mutate: refresh, isSuccess, isError } = useRefresh();
  useEffect(() => {
    refresh();
  }, []);
  if (isLoading) {
    return (
      <CenterBackground>
        <TailSpin height={"100px"} width={"100px"} color={"grey"}></TailSpin>
      </CenterBackground>
    );
  } else if (isSuccess || isError) {
    return (
      <ThemeProvider theme={theme}>
        <ToastContainer
          position="top-center" // 알람 위치 지정
          autoClose={5000} // 자동 off 시간
          hideProgressBar={false} // 진행시간바 숨김
          closeOnClick // 클릭으로 알람 닫기
          rtl={false} // 알림 좌우 반전
          pauseOnFocusLoss // 화면을 벗어나면 알람 정지
          draggable // 드래그 가능
          pauseOnHover // 마우스를 올리면 알람 정지
          theme="light"
          limit={1} // 알람 개수 제한
        />
        <Router />
      </ThemeProvider>
    );
  }
}

export default withClearCache(App);
